import axios from 'axios';
import { resolveBackendBaseUrl } from '../../../utils/runtimeConfig';

const API = `${resolveBackendBaseUrl()}/api`;

const authHeaders = () => {
  const token = localStorage.getItem('ktc_token') || localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchRouterMonitoringRouters = async ({ search, status, vendor, limit = 200 } = {}) => {
  const res = await axios.get(`${API}/router-monitoring/routers`, {
    headers: authHeaders(),
    params: { search: search || undefined, status: status || undefined, vendor: vendor || undefined, limit },
  });
  return res.data || { items: [] };
};

export const fetchRouterTrafficCurrent = async (routerId, { refresh = true } = {}) => {
  if (!routerId) return { ok: false, interfaces: [] };
  const res = await axios.get(`${API}/router-monitoring/routers/${encodeURIComponent(routerId)}/traffic/current`, {
    headers: authHeaders(),
    params: { refresh },
  });
  return res.data || { ok: false, interfaces: [] };
};

export const fetchRouterTrafficHistory = async (routerId, { interfaceName, minutes = 60, limit = 300 } = {}) => {
  if (!routerId) return { ok: false, samples: [] };
  const res = await axios.get(`${API}/router-monitoring/routers/${encodeURIComponent(routerId)}/traffic/history`, {
    headers: authHeaders(),
    params: { interface_name: interfaceName || undefined, minutes, limit },
  });
  return res.data || { ok: false, samples: [] };
};

export const fetchRouterInterfaces = async (routerId, { refresh = false } = {}) => {
  if (!routerId) return { ok: false, interfaces: [] };
  const res = await axios.get(`${API}/router-monitoring/routers/${encodeURIComponent(routerId)}/interfaces`, {
    headers: authHeaders(),
    params: { refresh },
  });
  return res.data || { ok: false, interfaces: [] };
};
